import MuiCloseIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';

interface ICloseIcon {
  onClick: () => void;
}

export function CloseIcon({ onClick }: ICloseIcon) {
  return (
    <Box sx={{ p: 2, textAlign: 'right' }}>
      <IconButton onClick={onClick}>
        <MuiCloseIcon sx={{ color: 'white', cursor: 'pointer' }} />
      </IconButton>
    </Box>
  );
}
